import { useEffect, useState } from 'react'
import { akamaiServiceStatus } from '../firebase/cloudFunction/akamaiCloudFunctions'
import { SUCCESS } from 'constants/constantAkamai'

const useAkamaiServiceStatus = () => {
  const [status, setStatus] = useState({ enabled: false, loading: true })

  useEffect(() => {
    let active = true

    const fetchStatus = async () => {
      let enabled = false
      try {
        const response = await akamaiServiceStatus()
        enabled = response?.data?.status === SUCCESS && response?.data?.data?.enabled === true
      } catch {
        enabled = false
      }
      if (active) {
        setStatus({ enabled, loading: false })
      }
    }

    void fetchStatus()
    return () => {
      active = false
    }
  }, [])

  return status
}

export default useAkamaiServiceStatus